import {
  PlayActivityFeed,
  type PlayActivityGroup,
} from "@softmax/product-ux/play";
import {
  activityTimeZone,
  formatRelative,
} from "../lib/activity/feed-calendar";
import { maxActivityRows } from "../lib/activity/build-feed";
import type { FeedDayGroup } from "../lib/types";
export function ActivityFeed({
  groups,
  now,
  maxRows = maxActivityRows,
}: {
  readonly groups: readonly FeedDayGroup[];
  readonly now: string;
  readonly maxRows?: number;
}) {
  let shown = 0;
  const visible: PlayActivityGroup[] = [];

  for (const group of groups) {
    if (shown >= maxRows) break;

    const rows = group.rows.slice(0, maxRows - shown);

    if (rows.length === 0) continue;

    visible.push({
      key: group.heading,
      heading: group.heading,
      rows: rows.map((row, index) => ({
        key: `${row.at}-${index}`,
        when: formatRelative({
          iso: row.at,
          now,
          timeZone: activityTimeZone,
        }),
        policyLabel: row.policyLabel,
        text: row.text,
        champion: row.champion,
        href: row.href,
      })),
    });
    shown += rows.length;
  }

  return <PlayActivityFeed groups={visible} />;
}
